import api from './api'

// Types
export interface FFInvite {
  id: string
  shipperId: string
  freightForwarderId?: string
  status: 'pending' | 'accepted' | 'declined' | 'expired'
  expiresAt: string
  createdAt: string
  shipperName?: string
  shipperTradingName?: string
  shipperDocument?: string
}

export interface RespondToInviteRequest {
  accept: boolean
  declineReason?: string
}

// API calls

/**
 * List pending invites received by the freight forwarder
 */
export async function getFFInvites(): Promise<FFInvite[]> {
  const response = await api.get('/freight-forwarder/invites')
  return response.data.invites
}

/**
 * Get count of pending invites (for badge)
 */
export async function getFFInvitesCount(): Promise<number> {
  const response = await api.get('/freight-forwarder/invites/count')
  return response.data.count
}

/**
 * Respond to an invite (accept or decline)
 */
export async function respondToInvite(
  inviteId: string,
  data: RespondToInviteRequest
): Promise<any> {
  const response = await api.post(`/freight-forwarder/invites/${inviteId}/respond`, data)
  return response.data
}
